import { INITIAL_USERS } from "../user/types"
import { DataState, DataActionTypes, ADD_DATA, UPDATE_DATA } from "./types"

const initialState: DataState = {
  data: [],
  users: [],
}

export function dataReducer(state = initialState, action: DataActionTypes) {
  switch (action.type) {
    case ADD_DATA:
      return {
        ...state,
        data: state.data.concat(action.payload.data),
        total: action.payload.total,
      }
    case UPDATE_DATA:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
      }
    case INITIAL_USERS:
      return {
        ...state,
        users: action.payload,
      }
    default:
      return state
  }
}
